import axios from 'axios';

const instance = axios.create({
    timeout: 10000,
});

const config = {
    // baseUrl : 'https://edge.api.brightcove.com/playback/v1',
    accountId : '5764318566001',
    // 2021.03.10 zaehun@tlab.co.kr
    // lambda api으로 내려받은 policyKey 값을 사용하도록 수정함
    // policyKey : 'BCpkADawqM0U3mi_PT566m5lvtapzMq3Uy7ICGGjGB6v4Ske7ZX_ynzj8ePedQJhH36nym_5mbvSYeyyHOOdUsZovyg2XlhV6rRspyYPw_USVNLaR0fB_AAL2HSQlfuetIPiEzbUs1tpNF9NtQxt3BAPvXdOAsvy1ltLPWMVzJHiw9slpLRgI2NUufc',
};

const makeUrl = (videoId, adConfig, brightcoveApi) => {
   let url = `${brightcoveApi}/accounts/${config.accountId}/videos/${videoId}`
   if (adConfig) url += `?ad_config_id=${adConfig}`
   return url
}

function playbackVod(videoId, adConfig, brightcoveApi, policyKey) {
    const url = makeUrl(videoId, adConfig, brightcoveApi)
    return instance.get(url,
        { headers: 
            {Accept: `application/json;pk=${policyKey}`,}
        });
}

export {
    playbackVod,
}